import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M8.64824 3.03979L1.21967 10.4684C0.926777 10.7613 0.926777 11.2361 1.21967 11.529L8.64824 18.9576L9.7089 17.8969L3.56062 11.7487L21 11.7487V10.2487L3.5607 10.2487L9.7089 4.10046L8.64824 3.03979Z" />
  </svg>
);
